import { ClickAwayListener, Paper, Popper } from "@mui/material";
import { useMemo, useRef } from "react";

export default function OptionsPopper({ open, onClose, anchorRef, children }) {
  const popperRef = useRef(null);
  const ignoreClickRef = useRef(false);

  const sameWidth = useMemo(
    () => ({
      name: "sameWidth",
      enabled: true,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: ({ state }) => {
        state.styles.popper.width = `${state.rects.reference.width}px`;
      },
      effect:
        ({ state }) =>
        () => {
          state.styles.popper.width = `${state.rects.reference.width}px`;
        },
    }),
    []
  );

  const handleClickAway = (event) => {
    if (ignoreClickRef.current) return; // ignore the focus-triggering click
    const anchor = anchorRef.current;
    const popperEl = popperRef.current;
    if (anchor?.contains(event.target) || popperEl?.contains(event.target)) {
      return; // click was on the input or inside the popper → don't close
    }
    onClose();
  };

  return (
    <Popper
      open={open}
      anchorEl={anchorRef.current}
      placement="bottom-start"
      modifiers={[sameWidth]}
      sx={{ zIndex: (t) => t.zIndex.modal }} // ensure above app content
    >
      <ClickAwayListener onClickAway={handleClickAway} mouseEvent="onMouseDown">
        <Paper
          id="list-paper-el"
          elevation={8}
          sx={{ ml: 1 }}
          onMouseDown={(e) => e.preventDefault()}
          ref={popperRef}
        >
          {children}
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
}
